
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 50 50","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M49.405 21.56H28.44V.595A.595.595 0 0027.844 0h-5.688a.598.598 0 00-.596.595V21.56H.595a.595.595 0 00-.595.596v5.688a.598.598 0 00.595.596H21.56v20.965a.595.595 0 00.596.595h5.688a.598.598 0 00.596-.595V28.44h20.965a.595.595 0 00.595-.596v-5.688a.598.598 0 00-.595-.596z","fill":"currentColor","fill-rule":"nonzero"}})])
          )
        }
      }
    